import { Diamond } from "lucide-react";

const PARTNERS = ["Emaar", "Damac", "Nakheel", "Sobha Realty", "Azizi", "Binghatti", "Arada", "Danube"];

export const PartnersMarquee = () => (
  <section data-testid="partners-section" className="py-16 border-y border-white/5 bg-ink-card/40">
    <p className="text-center text-xs uppercase tracking-[0.35em] text-zinc-500 mb-8">
      Trusted partners — Dubai's premier developers
    </p>
    <div className="overflow-hidden ticker-mask">
      <div className="flex whitespace-nowrap animate-marquee-slow w-max items-center">
        {[...PARTNERS, ...PARTNERS].map((p, i) => (
          <span key={i} className="mx-10 flex items-center gap-10" data-testid={`partner-${p.toLowerCase().replace(/\s/g, "-")}`}>
            <span className="font-serif text-2xl sm:text-3xl text-zinc-500 hover:text-gold-light transition-colors">{p}</span>
            <Diamond size={10} className="text-gold/50" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  </section>
);
